/* istanbul ignore file */
/**
 * Created by gboue on 11/30/22
 * File: IAMActions
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import IdentityService from '../services/IdentityService'

export const LoadFederations = (tsg_id) => {
  return new Promise(((resolve, reject) => {
    IdentityService.federations.list(tsg_id).then(({ data }) => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  }))
}

export const CreateFederationOwner = (tsg_id, domain, params) => {
  return new Promise((resolve, reject) => {
    IdentityService.federations.createOwner(tsg_id, domain, params).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const CreateFederationIdp = (tsg_id, domain, params) => {
  return new Promise((resolve, reject) => {
    IdentityService.federations.createIDP(tsg_id, domain, params).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const UpdateFederationIdp = (tsg_id, domain, idpId, params) => {
  return new Promise((resolve, reject) => {
    IdentityService.federations.updateIDP(tsg_id, domain, idpId, params).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const DeleteFederationOwner = (tsg_id, domain, email) => {
  return new Promise((resolve, reject) => {
    IdentityService.federations.deleteOwner(tsg_id, domain, email).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const DeleteFederation = (tsg_id, domain) => {
  return new Promise((resolve, reject) => {
    IdentityService.federations.delete(tsg_id, domain).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const GetSpMetadata = (tsg_id, domain) => {
  return new Promise((resolve, reject) => {
    IdentityService.federations.get(tsg_id, domain).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const GetMetadataUrl = (tsg_id, domain, metadataUrl, contentType) => {
  return new Promise((resolve, reject) => {
    IdentityService.federations.getMetadata(tsg_id, domain, metadataUrl, contentType).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

